export default __webpack_public_path__ + "static/media/lp01_header02_mobile.c0365248.jpg";